import Accordion from "react-bootstrap/Accordion";
import * as styles from "../../../../src/data/qmarketing-fuer-den-mittelstand/elements.module.css";
import { StaticImage } from "gatsby-plugin-image";
import logosLogo from "../../../../src/images/produkte/logo/logos.jpg";
import * as React from 'react';
export default {
  Accordion,
  styles,
  StaticImage,
  logosLogo,
  React
};